import * as types from '../actions/types';

const INITIAL_STATE = {
     host: {
         url: null,
         guestsExpanded: false 
     },
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
       
        case types.HOST_SET_URL:
            return { ...state, 
                  host: {
                       url: action.payload,
                        guestsExpanded: false 
                  }};

         case types.TOGGLE_GUESTS_EXPANDED: 
            
               return { 
                   host: {
                     url: state.host.url,
                     guestsExpanded:!state.host.guestsExpanded
                  }}
                   
        case types.CLEAR_GROUP_ORDER_INFO:
              return INITIAL_STATE; 

        default:
            return state;

    }
}

